module.exports = __webpack_public_path__ + "img/btn-right.282633da.png";